import { memo, useRef } from 'react';
import ArrowAnimation, { ArrowDirection } from './ArrowAnimation';
import GlowAnimation from './GlowAnimation';

interface IconProps {
  className?: string;
}

function SunsetIcon({ className }: IconProps) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  return (
    <svg
      ref={svgRef}
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="weather-icon-sunset"
    >
      <path
        d="M68.4485 34.9541C69.2102 35.754 69.179 37.0195 68.3791 37.7812L61.3791 44.4482C60.6068 45.1836 59.3937 45.1836 58.6213 44.4482L51.6213 37.7812C50.8215 37.0195 50.7902 35.754 51.552 34.9541C52.3136 34.1544 53.5792 34.1233 54.3791 34.8848L58.0002 38.334L58.0002 29C58.0002 27.8954 58.8956 27 60.0002 27C61.1048 27 62.0002 27.8954 62.0002 29L62.0002 38.334L65.6213 34.8848C66.4212 34.1233 67.6868 34.1544 68.4485 34.9541Z"
        fill="white"
      >
        <ArrowAnimation direction={ArrowDirection.Down} />
      </path>
      <g filter="url(#filter0_d_sunset)">
        <path
          d="M60 52C74.9117 52 87 64.0883 87 79C87 83.3108 85.9881 87.3849 84.1914 91H35.8086C34.0119 87.3849 33 83.3108 33 79C33 64.0883 45.0883 52 60 52Z"
          fill="#FFA51F"
        />
      </g>
      <path
        d="M96 89C97.1046 89 98 89.8954 98 91C98 92.1046 97.1046 93 96 93H24C22.8954 93 22 92.1046 22 91C22 89.8954 22.8954 89 24 89H96Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_sunset"
          x="17"
          y="36"
          width="86"
          height="71"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8">
            <GlowAnimation />
          </feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.852175 0 0 0 0 0.63208 0 0 0 0.8 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default memo(SunsetIcon);
